<template>
  <div class="addmore">
    <div class="addmore__header">
      <h1 class="medium-title">Add Location</h1>
    </div>
    <div v-if="!isLoading" class="addmore__content">
      <div class="addmore__content--left">
        <div class="addmore__content__fieldset">
          <div class="addmore__content__fieldset__field">
            <adx-input :label="`Location Name *`" :value.sync="dataLocation.name" :validation="['NotEmpty', 'MaxLength:50']" :ref="dataRef.name" :error.sync="error.name"/>
          </div>
        </div>
        <div class="addmore__content__fieldset">
          <div class="header">
            <span class="subhead strong">About Location</span>
          </div>
          <div :class="['addmore__content__fieldset__field', error.brand ? 'warning' : '']">
            <adx-single-search-dropdown :label="`Brand *`" :value.sync="dataLocation.brand" :optionsParam="brandOptions" :ref="dataRef.brand"/>
          </div>
          <p class="msg-error small-font" v-if="error.brand">{{ error.brand }}</p>
          <div class="addmore__content__fieldset__field">
            <adx-textarea :label="`Description *`" :value.sync="dataLocation.description" :validation="['NotEmpty']" :ref="dataRef.description" :error.sync="error.description"/>
          </div>
        </div>
        <div class="addmore__content__fieldset">
          <div class="header">
            <span class="subhead strong">Property</span>
          </div>
          <div :class="['addmore__content__fieldset__field', error.property ? 'warning' : '']">
            <adx-dropdown :label="`Property Type*`" class="dropdown" :value.sync="dataLocation.property" :options="propertyOptions" :ref="dataRef.property"/>
          </div>
          <p class="msg-error small-font" v-if="error.property">{{ error.property }}</p>
          <div class="addmore__content__fieldset__checkbox">
            <span class="small-font strong">Secondary Category</span>
            <div class="addmore__content__fieldset__checkbox__wrapper">
              <adx-multiple-checkbox :styleWrapperClass="`multiplecheckbox`" :value.sync="dataLocation.secondaryCategory" :options="propertyOptions" />
            </div>
          </div>
          <div class="addmore__content__fieldset__field">
            <adx-dropdown :label="`Surrounding`" class="dropdown category" :value.sync="dataLocation.surrounding" :options="surroundingOptions" />
          </div>
          <div class="addmore__content__fieldset__fields">
            <adx-dropdown :label="`Airport Terminal`" class="dropdown" :value.sync="dataLocation.airportTerminal" :options="terminalOptions" />
          </div>
        </div>
        <div class="addmore__content__fieldset">
          <div class="header">
            <span class="subhead strong">Detail Information</span>
          </div>
          <div class="addmore__content__fieldset__fields">
            <adx-input :label="`Traffic *`" :value.sync="dataLocation.traffic" :validation="['NotEmpty']" type="number" :ref="dataRef.traffic" :error.sync="error.traffic"/>
          </div>
          <div class="addmore__content__fieldset__fields">
            <adx-input :label="`Spending Average *`" :value.sync="dataLocation.spendingAverage" :validation="['NotEmpty']" :ref="dataRef.spendingAverage" :error.sync="error.spendingAverage" type="number"/>
          </div>
          <div :class="['addmore__content__fieldset__fields', error.spendingSubject ? 'warning' : '']">
            <adx-dropdown :label="`Spending Subject *`" :value.sync="dataLocation.spendingSubject" :options="spendingSubjectOptions"/>
          </div>
          <p class="msg-error small-font" v-if="error.spendingSubject">{{ error.spendingSubject }}</p>
          <div :class="['addmore__content__fieldset__fields', error.spendingPeriod ? 'warning' : '']">
            <adx-dropdown :label="`Spending Period *`" :value.sync="dataLocation.spendingPeriod" :options="spendingPeriodOptions"/>
          </div>
          <p class="msg-error small-font" v-if="error.spendingPeriod">{{ error.spendingPeriod }}</p>
          <div class="addmore__content__fieldset__field">
            <adx-single-search-dropdown :label="`Profile`" class="dropdown category" :value.sync="dataLocation.profile" :optionsParam="profileOptions" />
          </div>
        </div>
        <div class="addmore__content__fieldset">
          <div class="header">
            <span class="subhead strong">Address</span>
          </div>
          <div class="addmore__content__fieldset__field">
            <adx-textarea :label="`Street`" :value.sync="dataLocation.street"/>
          </div>
          <div class="addmore__content__fieldset__fields">
            <adx-single-search-dropdown :label="`Cluster`" class="dropdown" :value.sync="dataLocation.cluster" :optionsParam="clusterOptions" />
            <adx-single-search-dropdown :label="`City`" class="dropdown" :value.sync="dataLocation.city" :optionsParam="cityOptions" />
          </div>
          <div class="addmore__content__fieldset__fields">
            <adx-single-search-dropdown :label="`Province`" class="dropdown" :value.sync="dataLocation.province" :optionsParam="provinceOptions" />
            <adx-single-search-dropdown :label="`Country`" class="dropdown" :value.sync="dataLocation.country" :optionsParam="countryOptions" />
          </div>
          <div class="addmore__content__fieldset__field">
            <adx-input :label="`Zipcode`" :value.sync="dataLocation.zipcode" type="number"/>
          </div>
        </div>
        <div class="addmore__content__fieldset">
          <div class="header">
            <span class="subhead strong">Other</span>
          </div>
          <div class="addmore__content__fieldset__field">
            <adx-textarea :label="`Forbidden Ads`" :value.sync="dataLocation.forbiddenAds"/>
          </div>
          <div class="addmore__content__fieldset__field">
            <adx-textarea :label="`Audience Description`" :value.sync="dataLocation.audienceDesc"/>
          </div>
        </div>
      </div>
      <div class="addmore__content--right">
        <div class="addmore__content__side">
          <div class="addmore__content__side__header">
            <span class="subhead strong">Owner</span>
          </div>
          <div :class="['addmore__content__side__fieldset__content', error.owner ? 'warning' : '']">
            <adx-single-search-dropdown :label="`Owner *`" class="dropdown" :value.sync="dataLocation.owner" :optionsParam="userOptions" :ref="dataRef.owner"/>
          </div>
          <p class="msg-error small-font" v-if="error.owner">{{ error.owner }}</p>
          <div class="addmore__content__side__fieldset__content">
            <adx-single-search-dropdown :label="`Ownership Group`" class="dropdown" :value.sync="dataLocation.ownership" :optionsParam="ownershipOptions" />
          </div>
        </div>
        <div class="addmore__content__buttons">
          <button class="btn-large primary" @click="save">Save</button>
        </div>
      </div>
    </div>
    <div v-else><adx-loading slot="loading"/></div>
  </div>
</template>

<script>
import Input from '@/components/Form/Input'
import TextArea from '@/components/Form/TextArea'
import Dropdown from '@/components/Form/SelectDropdown'
import LoadingSpinner from '@/components/Loading/Secondary-white'
import InputTag from '@/components/Form/InputTag'
import Loading from '@/components/Loading/Primary'
import MultipleCheckbox from '@/components/Form/MultipleCheckbox'
import SingleSearchDropdown from '@/components/Dropdown/SingleSearchDropdown'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-admin-locations-add',
  components: {
    'adx-input': Input,
    'adx-textarea': TextArea,
    'adx-dropdown': Dropdown,
    'adx-input-tag': InputTag,
    'adx-loading-white': LoadingSpinner,
    'adx-loading': Loading,
    'adx-multiple-checkbox': MultipleCheckbox,
    'adx-single-search-dropdown': SingleSearchDropdown,
  },
  props: {

  },
  data() {
    return {
      isLoading: false,
      isLoadingSave: false,
      dataLocation: {
        name: null,
        brand: null,
        description: null,
        property: null,
        secondaryCategory: null,
        surrounding: null,
        airportTerminal: null,
        traffic: null,
        spendingAverage: null,
        spendingSubject: null,
        spendingPeriod: null,
        surrounding: null,
        profile: null,
        street: null,
        cluster: null,
        city: null,
        province: null,
        country: null,
        forbiddenAds: null,
        audienceDesc: null,
        zipcode: null,
        owner: null,
        ownership: null
      },
      error: {
        name: null,
        brand: null,
        property: null,
        description: null,
        traffic: null,
        spendingAverage: null,
        spendingSubject: null,
        spendingPeriod: null,
        owner: null
      },
      dataRef: {
        name: 'name',
        brand: 'brand',
        description: 'description',
        property: 'property',
        description: 'description',
        traffic: 'traffic',
        spendingAverage: 'spendingAverage',
        spendingSubject: 'spendingSubject',
        spendingPeriod: 'spendingPeriod',
        owner: 'owner'
      },
      brandOptions: [],
      profileOptions: [],
      propertyOptions: [],
      surroundingOptions: [],
      profileOptions: [],
      cityOptions: [],
      clusterOptions: [],
      countryOptions: [],
      provinceOptions: [],
      spendingPeriodOptions: [],
      spendingSubjectOptions: [],
      ownershipOptions: [],
      terminalOptions: [],
      userOptions: []
    }
  },
  computed: {

  },
  watch: {
    'dataLocation.brand': function () {
      this.error.brand = null
    },
    'dataLocation.property': function () {
      this.error.property = null
    },
    'dataLocation.spendingSubject': function () {
      this.error.spendingSubject = null
    },
    'dataLocation.spendingPeriod': function () {
      this.error.spendingPeriod = null
    },
    'dataLocation.owner': function () {
      this.error.owner = null
    },
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.initialLoad()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    initialLoad() {
      (async () => {
        this.isLoading = true

        // Filters data
        const { data } = await api.get(apiV2.deviceFilters, { needToken: true })
        this.mapOptions(data)

        const dataBrand = await api.get(apiV2.locationBrands, { needToken: true })
        dataBrand.data.map(obj => {
          this.brandOptions.push({
            label: obj.title,
            value: obj.id
          })
        })

        // Profile data
        const dataProfile = await api.get(apiV2.locationProfile, { needToken: true })
        dataProfile.data.map(obj => {
          this.profileOptions.push({
            label: obj.title,
            value: obj.id
          })
        })

        // Ownership data
        const dataOwnership = await api.get(apiV2.locationOwnership, { needToken: true })
        dataOwnership.data.map(obj => {
          this.ownershipOptions.push({
            label: obj.name,
            value: obj.id
          })
        })

        // Airport Terminal
        const dataTerminal = await api.get(apiV2.locationAirportTerminal, { needToken: true })
        dataTerminal.data.map(obj => {
          this.terminalOptions.push({
            label: obj.terminal_name,
            value: obj.id
          })
        })

        // Users
        const dataUser = await api.get(apiV2.users, { needToken: true })
        dataUser.data.map(user => {
          this.userOptions.push(
            {
              value: user.id,
              label: user.email
            }
          )
        })

        this.getSpendingOptions()

        this.isLoading = false
      })();
    },
    getSpendingOptions() {
      (async () => {
        let file1 = `/static/data/spending_period.json`;
        let file2 = `/static/data/spending_subject.json`;

        let request1 = await fetch(new Request(file1));
        let data1 = await request1.json();
        data1.spendingPeriod.map(period => {
          this.spendingPeriodOptions.push(
            {
              'label': period.label,
              'value': period.value
            }
          )
        })

        let request2 = await fetch(new Request(file2));
        let data2 = await request2.json();
        data2.spendingSubject.map(subject => {
          this.spendingSubjectOptions.push(
            {
              'label': subject.label,
              'value': subject.value
            }
          )
        })
      })();
    },
    mapOptions(data) {
      // Property type
      Object.keys(data.property_type).map((key, index) => {
        this.propertyOptions.push({
          label: key,
          value: data.property_type[key]
        })
      })

      // Surrounding
      Object.keys(data.surrounding).map((key, index) => {
        this.surroundingOptions.push({
          label: key,
          value: data.surrounding[key]
        })
      })

      // City and Cluster
      data.cities.map(city => {
        this.cityOptions.push({
          label: city.title,
          value: city.id
        })

        city.locations.map(loc => {
          this.clusterOptions.push({
            label: loc.location,
            value: loc.id
          })
        })
      })

      // Countries and Provinces
      data.countries.map(cou => {
        this.countryOptions.push({
          label: cou.title,
          value: cou.id
        })

        cou.provinces.map(pro => {
          this.provinceOptions.push({
            label: pro.title,
            value: pro.id
          })
        })
      })
    },
    validateForm() {
      let data = { isValid: true, id: null }
      let dataRef = this.dataRef

      for (let key in dataRef) {
        const value = this.dataLocation[key]
        if (value == null || this.inputInvalid(dataRef[key])) {
          data.isValid = false
          data.id = dataRef[key]
          break
        }
      }

      return data
    },
    raiseError(id) {
      let dropdownField = ['brand', 'property', 'spendingSubject', 'spendingPeriod', 'owner']
      if (dropdownField.includes(id)) {
        this.error[id] = 'You can’t leave this ' + id.charAt(0).toUpperCase() + id.slice(1) + ' empty'
        if (id == 'spendingSubject') {
          this.error[id] = 'You can’t leave this Spending subject * empty'
        } else if (id == 'spendingPeriod') {
          this.error[id] = 'You can’t leave this Spending period * empty'
        }
      } else {
        let element = this.$refs[id].$el.firstElementChild
        element.focus()
        element.blur()
      }
    },
    inputInvalid(value) {
      let error = false
      let dataRef = this.dataRef

      switch(value) {
        case dataRef.name:
          error = this.error.name
          break
        case dataRef.description:
          error = this.error.description
          break
        case dataRef.traffic:
          error = this.error.traffic
          break
        case dataRef.spendingAverage:
          error = this.companyAddressError
          break
      }
      return error
    },
    save() {
      (async () => {

        let validation = this.validateForm()
        if (validation.isValid) {
          let data = {
            brand: this.dataLocation.brand,
            title: this.dataLocation.name,
            description: this.dataLocation.description,
            property_type: this.dataLocation.property,
            secondary_categories: this.dataLocation.secondaryCategory,
            surrounding: this.dataLocation.surrounding,
            airport_terminal: this.dataLocation.airportTerminal,
            street: this.dataLocation.street,
            cluster: this.dataLocation.cluster,
            province: this.dataLocation.province,
            city: this.dataLocation.city,
            country: this.dataLocation.country,
            zipcode: this.dataLocation.zipcode,
            traffic: this.dataLocation.traffic,
            profile: this.dataLocation.profile,
            spending_average: this.dataLocation.spendingAverage,
            spending_subject: this.dataLocation.spendingSubject,
            spending_period: this.dataLocation.spendingPeriod,
            forbidden_ads: this.dataLocation.forbiddenAds,
            audience_description: this.dataLocation.audienceDesc,
            owner: this.dataLocation.owner,
            ownership_group: this.dataLocation.ownership,
          }

          const response = await api.post(apiV2.locationAdminNew, data, { needToken: true })
          if (response.status == 201) {
            this.$notify({
              group: 'saved',
              title: 'Save success',
              text: 'Data successfully saved!',
              type: 'success'
            });
            this.$router.push({name: 'alllocation'})
          } else {
            this.$notify({
              group: 'saved',
              title: 'Save error',
              text: 'Oops data can not be saved!',
              type: 'danger'
            });
          }
        } else {
          this.raiseError(validation.id)
        }

      })();
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
  .addmore__content--left {
    .selectDropdown {

      .select {
        .standardInput {
          padding: 16px !important;
          padding-top: 24px !important;
        }

        .standardLabel {
          display: unset;
        }
      }

      .popup {
        max-height: 300px;
        overflow-y: auto !important;
      }
    }
  }
</style>
